import {EndoDiagnosisDataModel} from '../models/endo-diagnosis-data.model';
import {StaticDataService} from '../../../../../services/static-data.service';
import {TreatmentEndoPerforationDataModel} from '../../../../treatment/models/treatment-endo-perforation-data.model';
import {TreatmentFracturesModel} from '../../../../treatment/models/treatment-fractures.model';
import {ToothConfigurationModel} from '../../../../../models/teeth/tooth-configuration.model';

export class DiagnosisUtils {
  staticDataService: StaticDataService;
  getNoteString(model: EndoDiagnosisDataModel, staticDataService: StaticDataService, retrPerforations: TreatmentEndoPerforationDataModel, repaPerforations: TreatmentEndoPerforationDataModel, cetrFractures: TreatmentFracturesModel[], tooth: ToothConfigurationModel) {
    this.staticDataService = staticDataService;
    let note = 'Diagnosis of tooth: ' + tooth.cfgToothDescriptions.find(f=> f.enumToothNumberingId==='00000028-1000-0000-0000-000000000001').Notation+"\r\n";

    let trNote = '';

    // Radiographic Examination Tooth and Root
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    trNote += this.checkBool(model.retr_isWNL, 'WNL');
    trNote += this.checkBoolQuestionable(model.retr_isCaries, model.retr_isCaries_Q, 'Caries');
    trNote += this.checkBool(model.retr_isRestoaration, 'Restoration');
    // Block
    trNote += this.checkBool(model.retr_isCalcification, 'Calcification: ', true);
    trNote += this.checkVal(model.retr_Calcification, '', true);
    trNote += ' ' + this.checkEnum(model.retr_enumDiagCalcificationID, '');
    //
    trNote += this.checkBoolQuestionable(model.retr_isCrounFeac, model.retr_isCrounFeacture_Q, 'Crown Fracture');
    trNote += this.checkBoolQuestionable(model.retr_isRootFracture, model.retr_isRootFracture_Q, 'Root Fracture');
    trNote += this.checkEnum(model.retr_enumDiagECIRID, 'ECIR: ', false);
    // Block
    trNote += this.checkBool(model.retr_isRootPerforation, 'Root Perforation', true);
    const perfs = this.checkPerforationDialog(retrPerforations);
    if (perfs.length > 0) {
      trNote += ': ' + perfs;
    }
    trNote += this.checkBoolQuestionable(model.retr_isLatroCrownPerf, model.retr_isLatroCrownPerf_Q, 'Latro. Crown Perf');
    trNote += this.checkBool(model.retr_isOpenApex, 'Open Apex');
    trNote += this.checkBoolQuestionable(model.retr_isDiaceration, model.retr_isDiaceration_Q, 'Dilaceration');
    trNote += this.checkBool(model.retr_isSuspAnomalAnatomy, 'Susp Anomaly Anatomy');
    trNote += this.checkBool(model.retr_isRotatedTipped, 'Rotated / Tipped');
    trNote += this.checkBool(model.retr_isPostBuildup, 'Post / Buildup');
    trNote += this.checkBool(model.retr_isFracturedPost, 'Fractured Post');
    trNote += this.checkBool(model.retr_isResorptivePerf, 'Resorptive Perf');
    trNote += this.checkBool(model.retr_isResorptionInFlam, 'Resorption (in flam)');
    trNote += this.checkBool(model.retr_isPoorCRltOne, 'Poor C/R (<1:1');
    trNote += this.checkBool(model.retr_isIntaernalRR, 'Internal RR');
    trNote += this.checkBool(model.retr_isExternalRR, 'External RR');
    trNote += this.checkBool(model.retr_isReplacementRR, 'Replacement RR');
    trNote += this.checkEnum(model.retr_enumDiagCanalCuravatureID, 'Canal Curvature: ');
    trNote += this.checkEnum(model.retr_enumDiagViatalStructureProxID, 'Vital Structures Proximity: ');
    if (trNote.length > 0) {
      note += 'Tooth and Root\r\n';
      note += '================\r\n';
      note += trNote;
      //note += '\r\n';
    }

    let bNote = '';
    bNote += this.checkBool(model.reb_isAlveolarBoneWNL, 'Alveolar Bone WNL');
    bNote += this.checkBool(model.reb_isPDLnormal, 'PDL Normal');
    bNote += this.checkBool(model.reb_isPDLThickend, 'PDL Thickened');
    bNote += this.checkBool(model.reb_isLaminaDura, 'Lamina Dura', true);
    if (!model.reb_enumDiagLaminaDuraID && bNote.length > 0) {
      bNote += '\r\n';
    }
    bNote += this.checkEnum(model.reb_enumDiagLaminaDuraID, ': ');
    bNote += this.checkBool(model.reb_isDiffuseLucency, 'Diffuse Lucency ', true);
    const rebDiff = model.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'reb_DiffuseLucency');
    if (rebDiff) {
      let i = 0;
      for (const r of rebDiff.dataEndoDiagnosisToothDetailSCs) {
        if (i === 0) {
          bNote += ': ';
          bNote += this.checkEnum(r.enumToothCanalID, '', true);
        } else {
          bNote += ', ' + this.checkEnum(r.enumToothCanalID, '', true);
        }
        i++;
      }
    }
    bNote += this.checkEnum(model.reb_enumDiagLucency_DiffuseID, ' - ', true);
    if (bNote.length > 0) {
      bNote += '\r\n';
    }

    bNote += this.checkBool(model.reb_isDiffuseLucency, 'Circum Lucency ', true);
    const circDiff = model.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'reb_isCircumLucency');
    if (circDiff) {
      let i = 0;
      for (const r of circDiff.dataEndoDiagnosisToothDetailSCs) {
        if (i === 0) {
          bNote += ': ';
          bNote += this.checkEnum(r.enumToothCanalID, '', true);
        } else {
          bNote += ', ' + this.checkEnum(r.enumToothCanalID, '', true);
        }
        i++;
      }
    }
    bNote += this.checkEnum(model.reb_enumDiagLucency_CircumID, ' - ', true);
    if (bNote.length > 0) {
      bNote += '\r\n';
    }
    //
    bNote += this.checkBool(model.reb_isLateralRootLesion, 'Lateral Root Lesion');
    bNote += this.checkBool(model.reb_isFurcalBreakdown, 'Furcal Breakdown');
    bNote += this.checkBool(model.reb_isHypercementosis, 'Hypercementosis');
    bNote += this.checkBool(model.reb_isOsteosclCondOst, 'Osteoscl / Cond Ost');
    bNote += this.checkBool(model.reb_isPerioDisease, 'Perio Disease');
    bNote += this.checkBool(model.reb_isBoneGraft, 'Bone Graft');
    bNote += this.checkBool(model.reb_isCircumfWrapArround, 'Circumf / Wrap Around');
    bNote += this.checkBool(model.reb_isPerioEndoEndoPerio, 'Perio-Endo / Endo-Perio');
    // Block
    bNote += this.checkBool(model.reb_isBoneLoss, 'Bone Loss', true);
    bNote += this.checkEnum(model.reb_enumDiagBoneLoss_AID, ' A: ', true);
    bNote += this.checkEnum(model.reb_enumDiagBoneLoss_BID, ' B: ', true);

    if (bNote.length > 0) {
      note += '\r\nBone\r\n';
      note += '================\r\n';
      note += bNote;
      note += '\r\n';
    }

    // Prior Attempted Treatment
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    let paNote = '';
    paNote += this.checkBool(model.repa_isAdequateRCT, 'Adequate RCT');
    paNote += this.checkBoolQuestionable(model.repa_isPulpCap, model.repa_isPulpCap_Q, 'Pulp Cap');
    paNote += this.checkBool(model.repa_isPriorPulpotomy, 'Prior Pulpotomy');
    paNote += this.checkBool(model.repa_isPulpectomy, 'Pulpectomy');
    paNote += this.checkBoolQuestionable(model.repa_isSargentiPaste, model.repa_isSargentiPaste_Q, 'Sargenti / Paste');
    paNote += this.checkBoolQuestionable(model.repa_isTermaFill, model.repa_isTermaFill_Q, 'Termi Fill');
    paNote += this.checkBool(model.repa_isAGPT, 'AG PT');
    paNote += this.checkBoolQuestionable(model.repa_isMissedCanals, model.repa_isMissedCanals_Q, 'Missed Canal(s)');
    paNote += this.checkBool(model.repa_isSepInst, 'Sep Inst', true);
    paNote += this.checkEnum(model.repa_enumDiagSepInstID, ': ');
    paNote += this.checkBool(model.repa_isCanalObstruction, 'Canal Obstruction', true);
    paNote += this.checkEnum(model.repa_enumDiagCanalObstructionID, ': ');
    paNote += this.checkBool(model.repa_isOverextRCTfilling, 'Overext: RCT Filling');
    paNote += this.checkBool(model.repa_isIncompleteInadequateRCT, 'Incomplete / Inadequate RCT', true);
    paNote += this.checkEnum(model.repa_enumDiagIncompleteInadequateRCT_1ID, ' : ', true);
    paNote += this.checkEnum(model.repa_enumDiagIncompleteInadequateRCT_2ID, ' : ', true);
    paNote += this.checkEnum(model.repa_enumDiagIncompleteInadequateRCT_3ID, ' : ', true);
    if (paNote.length > 0) {
      paNote += '\r\n';
    }

    paNote += this.checkBool(model.repa_isRootPerforation, 'Root Perforation', true);
    const perfs1 = this.checkPerforationDialog(repaPerforations);
    if (perfs1.length > 0) {
      paNote += ': ' + perfs1;
    }

    paNote += this.checkBoolQuestionable(model.repa_isLedgedZipped, model.repa_isLedgedZipped, 'Ledged / Zipped');
    paNote += this.checkBool(model.repa_isPriorApicalSurgery, 'Prior Apical Surgery');
    paNote += this.checkBool(model.repa_isPriorRootAmp, 'Prior Root Amputation');
    paNote += this.checkBool(model.repa_isPriorHemisect, 'Prior Hemisect');

    if (paNote.length > 0) {
      note += 'Prior Attempted Treatment\r\n';
      note += '================\r\n';
      note += paNote;
      note += '\r\n';
    }

    // Tooth and Restorations
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    let restNote = '';
    restNote += this.checkBool(model.cetr_isNoRestorations, 'No Restorations');
    restNote += this.checkEnum(model.cetr_enumDiagRestorabilityIndexID, 'TRI: ');
    restNote += this.checkBool(model.cetr_isDiscoloration, 'Discoloration');
    restNote += this.checkBoolQuestionable(model.cetr_isPriorBleaching, model.cetr_isPriorBleaching, 'Prior Bleaching');
    restNote += this.checkBool(model.cetr_isCaries, 'Caries ', true);
    const cetrDiff = model.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'cetr_Caries');
    if (cetrDiff) {
      let i = 0;
      for (const r of cetrDiff.dataEndoDiagnosisToothDetailSCs) {
        if (i === 0) {
          note += ': ';
          note += this.checkEnum(r.enumToothSurfaceID, '', true);
        } else {
          note += ', ' + this.checkEnum(r.enumToothSurfaceID, '', true);
        }
        i++;
      }
    }
    if (restNote.length > 0) {
      restNote += '\r\n';
    }
    restNote += this.checkBool(model.cetr_isSubgingDecay, 'Subging Decay', true);
    const cetrSub = model.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'cetr_SubgingDecay');
    if (cetrSub) {
      let i = 0;
      for (const r of cetrSub.dataEndoDiagnosisToothDetailSCs) {
        if (i === 0) {
          restNote += ': ';
          restNote += this.checkEnum(r.enumToothSurfaceID, '', true);
        } else {
          restNote += ', ' + this.checkEnum(r.enumToothSurfaceID, '', true);
        }
        i++;
      }
    }
    if (restNote.length > 0) {
      restNote += '\r\n';
    }
    restNote += this.checkBoolQuestionable(model.cetr_isDefectiveRestorations, model.cetr_isDefectiveRestorations_Q, 'Defective Restorations', true);
    restNote += this.checkEnum(model.cetr_enumDiagDefectiveRestorationsID, ': ');
    restNote += this.checkBool(model.cetr_isCervicalErosion, 'Cervical Erosion');
    restNote += this.checkBool(model.cetr_isCervicalErosion, 'Abfraction Lesion');
    restNote += this.checkBool(model.catr_isAttritionAbrasion, 'Attrition / Abrasion');
    restNote += this.checkBool(model.catr_isPriorAccess, 'Prior Access');
    restNote += this.checkBool(model.catr_isOpenTooth, 'Open Tooth');
    restNote += this.checkBoolQuestionable(model.catr_isCrounFracture, model.catr_isCrounFracture_Q, 'Crown Fracture', true);
    restNote += this.checkBool(model.catr_isFractures, 'Fractures', true);
    for (const fracture of cetrFractures) {
      // fracture.
      restNote += 'Tooth #' + tooth.cfgToothDescriptions[0].Notation;
      if (fracture.enumEndoFractureLocationID) {
        restNote += ' ==> ' + this.checkEnum(fracture.enumEndoFractureLocationID, '', true);
      }
      if (fracture.enumEndoFractureTypeID) {
        restNote += ' ==> ' + this.checkEnum(fracture.enumEndoFractureTypeID, '', true);
      }
      if (fracture.enumEndoFractureExtensionID) {
        restNote += ' ==> ' + this.checkEnum(fracture.enumEndoFractureExtensionID, '', true);
      }
      if (fracture.enumEndoFractureTransilluminationID) {
        restNote += ' ==> ' + this.checkEnum(fracture.enumEndoFractureTransilluminationID, '', true);
      }
    }
    if (restNote.length > 0) {
      restNote += '\r\n';
    }
    restNote += this.checkEnum(model.catr_enumDiagRestorationID, 'Restoration: ');
    restNote += this.checkEnum(model.catr_enumDiagCrownCementedID, 'Crown Cemented: ');
    restNote += this.checkBool(model.cetr_isAbutment, 'Abutment');
    restNote += this.checkBool(model.cetr_isFractPorcelain, 'Fractured Porcelain');
    restNote += this.checkBoolQuestionable(model.cetr_isCrnlLeakage, model.cetr_isCrnlLeakage_Q, 'Coronal Leakage');
    restNote += this.checkBoolQuestionable(model.cetr_isBrCrLoose, model.cetr_isBrCrLoose_Q, 'Br / Cr Loose', true);
    restNote += this.checkEnum(model.cetr_enumDiagBrCRID, ': ');
    restNote += this.checkBoolQuestionable(model.cetr_isIatrogenicCrownPerf, model.cetr_isIatrogenicCrownPerf_Q, 'Iatrogenic Crown Perf');
    restNote += this.checkBool(model.cest_isWNL, 'WNL');
    restNote += this.checkBool(model.cest_isEOSwelling, 'EO Swelling');
    restNote += this.checkBool(model.cest_isEOSwelling_Indurated, '- Indurated');
    restNote += this.checkBool(model.cest_isEOSwelling_Fluctuant, '- Fluctuant');
    restNote += this.checkBool(model.cest_isEOSwelling_SinusTrack, '- Sinus Tract');
    restNote += this.checkBool(model.cest_isIOSwelling, 'IO Swelling');
    restNote += this.checkBool(model.cest_isIOSwelling_Indurated, '- Indurated');
    restNote += this.checkBool(model.cest_isIOSwelling_Fluctuant, '- Fluctuant');
    restNote += this.checkBool(model.cest_isIOSwelling_DrainingThruSulcus, '- Draining Through Sulcus');
    restNote += this.checkEnum(model.cest_enumDiagSwellingID, ': Facial Space Swelling');
    restNote += this.checkBool(model.cest_isSinusTrack, 'Sinus Track');
    restNote += this.checkBool(model.cest_isSinusTrack_B, '- B');
    restNote += this.checkBool(model.cest_isSinusTrack_L, '- L');
    restNote += this.checkBool(model.cest_isSinusTrack_Sulcus, '- Sulcus');
    restNote += this.checkEnum(model.cest_enumDiagSinusTrackTimeID, 'Time: ');
    restNote += this.checkBool(model.cest_isLymphad, 'Lymphad');
    restNote += this.checkEnum(model.cest_enumDiagFebrileID, 'Febrile: ');
    restNote += this.checkBool(model.cest_isPerioAbscess, 'Perio Abscess');
    restNote += this.checkEnum(model.cest_enumDiagFurcationID, 'Furcation: ');
    restNote += this.checkBool(model.cest_isPerioAbscess, 'Resorption / Perferation');
    restNote += this.checkEnum(model.cest_enumDiagTraumaTimeID, 'Trauma: ');
    restNote += this.checkBool(model.cest_isSoftTissueExam, 'Soft Tissue Exam');
    if (model.cest_isSoftTissueExam) {
      restNote += 'Date: ' + model.cest_SoftTissueExamDate + '\r\n';
    }
    restNote += this.checkBool(model.cest_isGingivalRecession, 'Gingival Recession', true);
    restNote += this.checkEnum(model.cest_enumDiagGingivalRecession_BID, ' ', true);
    restNote += this.checkEnum(model.cest_enumDiagGingivalRecession_LID, ' ', true);
    if (restNote.length > 0) {
      restNote += '\r\n';
    }
    restNote += this.checkEnum(model.cest_enumDiagSoftTissueID, 'Soft Tissue (lip, tongue, etc)');
    restNote += this.checkBool(model.cest_isGingivalRecession, 'Gingivitis');
    restNote += this.checkBool(model.cest_isGingHypertrophy, 'Ging Hypertrophy');
    restNote += this.checkBool(model.cest_isPeriodontalDesease, 'Periodontal Disease');
    restNote += this.checkBool(model.cest_isPriorPerioSurgery, 'Prior Perio Surgery');
    if (model.cest_PriorPerioSurgeryDate) {
      restNote += new Date(model.cest_PriorPerioSurgeryDate).toLocaleDateString() + '\r\n';
    }
    restNote += this.checkBool(model.cest_isMaxillaryTori, 'Maxillary Tori');
    restNote += this.checkBool(model.cest_isMaxillaryTori_B, ' - Buccal');
    restNote += this.checkBool(model.cest_isMaxillaryTori_P, ' - Palatal');
    restNote += this.checkBool(model.cest_isMandibularTori, 'Mandibular Tori');
    restNote += this.checkBool(model.cest_isMandibularTori_B, ' - Buccal');
    restNote += this.checkBool(model.cest_isMandibularTori_L, ' - Lingual');
    restNote += this.checkBool(model.cest_isLimitedLipFlex, 'Limited Lip Flex');
    restNote += this.checkBool(model.cest_isPriorIandD, 'Prior I and D', true);
    if (model.cest_PriorIandDdate) {
      restNote += new Date(model.cest_PriorIandDdate).toLocaleDateString() + '\r\n';
    }

    if (restNote.length > 0) {
      note += 'Tooth and Restorations\r\n';
      note += '================\r\n';
      note += restNote;
      note += '\r\n';
    }

    let oNote = '';
    oNote += this.checkBool(model.ceob_isNOOcclusion, 'No Occlusion');
    oNote += this.checkBoolQuestionable(model.ceob_isOcclusalTrauma, model.ceob_isOcclusalTrauma_Q, 'No Occlusion');
    oNote += this.checkBool(model.ceob_isWaresNightSplint, 'Ware night splint');
    oNote += this.checkEnum(model.ceob_enumDiagLimitedOpeningID, 'Limited opening: ');
    oNote += this.checkBool(model.ceob_isWaresNightSplint, 'TMJ Disease');
    oNote += this.checkBool(model.ceob_isRMoscleSoreness, 'R Muscle Soreness', true);
    oNote += this.checkEnum(model.ceob_enumDiagMoscleSoreness_RID, ': ', true);
    oNote += this.checkEnum(model.ceob_enumDiagMoscleSoreness_LID, '');
    oNote += this.checkBool(model.ceob_isDentalPhobic, 'Dental Phobic');
    oNote += this.checkBool(model.ceob_isPriorBadDentalExperiance, 'Prior bad dental experience');
    oNote += this.checkBool(model.ceob_isBadTasteDrain, 'Bad taste drainage');
    oNote += this.checkBool(model.ceob_isGaggerClaustrophobic, 'Gagger / Claustrophobic');
    oNote += this.checkBool(model.ceob_isHeavySalivation, 'Heavy Salivation');
    oNote += this.checkBool(model.ceob_isCanNotBeReclined, 'Cannot be Reclind');
    oNote += this.checkBool(model.ceob_isLargeActiveTongue, 'Large / Active Tongue');
    oNote += this.checkBool(model.ceob_isLPT, 'LPT');
    oNote += this.checkBool(model.ceob_isLDIQ, 'LDIQ');
    oNote += this.checkBool(model.ceob_isIntangible1, 'Intangible 1');
    oNote += this.checkBool(model.ceob_isIntangible2, 'Intangible 2');
    oNote += this.checkBool(model.ceob_isIntangible3, 'Intangible 3');
    oNote += this.checkBool(model.ceob_isAnesthetizedByGP, 'Anesthetized');
    oNote += this.checkEnum(model.ceob_enumDiagAnesthesiaTypeID, 'Type: ');
    oNote += this.checkEnum(model.ceob_enumDiagAnesthesiaLengthID, 'How long: ');
    oNote += this.checkBool(model.ceob_isAnalgesicsPriorToAppt, 'Analgesics prior to appt');
    oNote += this.checkBool(model.ceob_isPoorOH, 'Poor OH');
    oNote += this.checkBool(model.ceob_isTakingAntibiotics, 'Taking Antibiotics');
    oNote += this.checkBool(model.ceob_isOpposingDentition, 'Opposing Detention', true);
    oNote += this.checkEnum(model.ceob_enumDiagOpposingDentitionID, ': ');

    if (oNote.length > 0) {
      note += 'Occlusion / Behavioral\r\n';
      note += '================\r\n';
      note += oNote;
    }

    note += '\r\n';
    note += '\r\n';
    if (model.thisDiagnosisCompleted) {
      note += 'Completed: ' + new Date(model.thisDiagnosisCompleted).toLocaleDateString();
    }
    note += '\r\n';
    note += 'Difficulty Level: ' + model.DifficultyLevel + '\r\n';

    return note;
  }

  checkBool(prop: boolean, name: string, isNoLinebreak: boolean = false) {
    let lb = '\r\n';
    if (isNoLinebreak) {
      lb = '';
    }
    if (prop != null && prop) {
      return name + lb;
    } else {
      return '';
    }
  }

  checkBoolQuestionable(prop: boolean, propQ,  name: string, isNoLinebreak: boolean = false) {
    let lb = '\r\n';
    if (isNoLinebreak) {
      lb = '';
    }
    if (prop != null && prop) {
      let r = name;
      if (propQ != null && propQ) {
        r = 'Possible ' + name + lb;
      } else {
        r += lb;
      }
      return r;
    } else {
      return '';
    }
  }

  checkVal(val: number, name: string, isNoLinebreak: boolean = false) {
    let lb = '\r\n';
    if (isNoLinebreak) {
      lb = '';
    }
    if (val > 0) {
      return name + ' ' + val + lb;
    } else {
      return '';
    }
  }

  checkEnum(id: string, name: string, isNoLinebreak: boolean = false) {
    if (id === null) {
      return '';
    }

    let lb = '\r\n';
    if (isNoLinebreak) {
      lb = '';
    }
    const enu = this.staticDataService.getValidValueItemsByItemIds([id]);
    if (enu && enu[0] !== undefined)  {
      return name + enu[0].ItemDisplayValue + lb;
    } else {
      return '';
    }
  }

  checkPerforationDialog(model: TreatmentEndoPerforationDataModel) {
    if (!model) {
      return '';
    }
    let str = '';
    if (model.enumToothCanalID != null) {
      str += this.checkEnum(model.enumToothCanalID, '', true) + ' ==> ';
    }

    if (model.enumEndoPerfCrestalID != null) {
      str += this.checkEnum(model.enumEndoPerfCrestalID, '', true) + ' ==> ';
    }

    if (model.enumEndoPerfSizeID != null) {
      str += this.checkEnum(model.enumEndoPerfSizeID, '', true) + ' ==> ';
    }

    if (model.enumEndoPerfTypeID != null) {
      str += this.checkEnum(model.enumEndoPerfTypeID, '', true) + ' ==> ';
    }

    if (model.enumEndoPerfCausedByID != null) {
      str += this.checkEnum(model.enumEndoPerfCausedByID, '', true) + ' ==> ';
    }

    if (model.enumEndoPerfPriorRepaireID != null) {
      str += this.checkEnum(model.enumEndoPerfPriorRepaireID, '', true) + ' ==> ';
    }

    if (model.enumEndoPerfTimeSincePerfID != null) {
      str += this.checkEnum(model.enumEndoPerfTimeSincePerfID, '', true) + ' ==> ';
    }

    if (model.enumEndoPerfRepairMaterialID != null) {
      str += this.checkEnum(model.enumEndoPerfRepairMaterialID, '', true) + ' ==> ';
    }

    if (str.lastIndexOf(' ==> ') === str.length - 5) {
      str = str.substring(0, str.length - 5);
    }

    return str;
  }
}
